// This import cannot be shortened without creating circular dependencies.
import { ModuleReferenceNodeModelForm } from '@app/page-components/app/canvas/node-forms';
import { NodeTypeName } from "@app/types";
import BaseNodeModel from "../BaseNodeModel";

export default class ModuleReferenceNodeModel extends BaseNodeModel {
    constructor(
        nodeName = "UNTITLED_NODE",
        x = 0,
        y = 0,
        props = null,
        id = null
    ) {
        super(nodeName, x, y, null, id);
        this.props.nodeTypeName = NodeTypeName.moduleReference;
        this.props.colorClass = "blue";
        this.props.iconClass = "command";
        this.DEFAULT_COLOR_CLASS = "blue";
        this.applyProps(props);
    }

    getConfigViews() {
        return [
            <ModuleReferenceNodeModelForm key="form" object={this} />
        ];
    }
}